/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { Modal, ModalBody, Form, Label, Spinner } from "reactstrap";
import { Icon, Col, Button } from "../../../components/Component";
import DatePicker from "react-datepicker";
import useEventForm from "../form/use-event-form";
import { Controller } from "react-hook-form";

const DateItemPicker = ({ index, control, item, errors, fields, remove }) => {
  return (
    <div
      key={item.id}
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 8,
        width: "100%",
        flexWrap: "nowrap",
      }}
    >
      <div style={{ flex: "1 1 0", minWidth: 0 }}>
        <div className="form-group">
          <Label className="form-label" htmlFor="start-date">
            Start Date *
          </Label>

          <Controller
            name={`dates[${index}].start.date`}
            control={control}
            render={({ field }) => (
              <div>
                <div className="form-control-wrap">
                  <div className="input-group">
                    <DatePicker
                      {...field}
                      selected={field.value}
                      onChange={(date) => field.onChange(date)}
                      showTimeCaption={false}
                      dateFormat="dd/MM/yyyy"
                      required
                      className="form-control date-picker"
                    />
                  </div>
                </div>
                {errors.dates &&
                  errors.dates[index] &&
                  errors.dates[index].start &&
                  errors.dates[index].start.date && (
                    <span className="invalid-message">
                      {errors.dates[index].start.date.message}
                    </span>
                  )}
              </div>
            )}
          />
        </div>
      </div>
      <div style={{ flex: "1 1 0", minWidth: 0 }}>
        <div className="form-group">
          <Label className="form-label" htmlFor="start-time">
            Start Time
          </Label>

          <Controller
            name={`dates[${index}].start.time`}
            control={control}
            render={({ field }) => (
              <div>
                <div className="form-control-wrap">
                  <input
                    {...field}
                    type="time"
                    step={900}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value || null)}
                    className="form-control"
                  />
                </div>
                {errors.dates &&
                  errors.dates[index] &&
                  errors.dates[index].start &&
                  errors.dates[index].start.time && (
                    <span className="invalid-message">
                      {errors.dates[index].start.time.message}
                    </span>
                  )}
              </div>
            )}
          />
        </div>
      </div>
      <div style={{ flex: "1 1 0", minWidth: 0 }}>
        <div className="form-group">
          <Label className="form-label" htmlFor="end-date">
            End Date *
          </Label>

          <Controller
            name={`dates[${index}].end.date`}
            control={control}
            render={({ field }) => (
              <div>
                <div className="form-control-wrap">
                  <div className="input-group">
                    <DatePicker
                      {...field}
                      selected={field.value}
                      onChange={(date) => field.onChange(date)}
                      showTimeCaption={false}
                      dateFormat="dd/MM/yyyy"
                      required
                      className="form-control date-picker"
                    />
                  </div>
                </div>
                {errors.dates &&
                  errors.dates[index] &&
                  errors.dates[index].end &&
                  errors.dates[index].end.date && (
                    <span className="invalid-message">
                      {errors.dates[index].end.date.message}
                    </span>
                  )}
              </div>
            )}
          />
        </div>
      </div>
      <div style={{ flex: "1 1 0", minWidth: 0 }}>
        <div className="form-group">
          <Label className="form-label" htmlFor="end-time">
            End Time
          </Label>

          <Controller
            name={`dates[${index}].end.time`}
            control={control}
            render={({ field }) => (
              <div>
                <div className="form-control-wrap">
                  <input
                    {...field}
                    type="time"
                    step={900}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value || null)}
                    className="form-control"
                  />
                </div>
                {errors.dates &&
                  errors.dates[index] &&
                  errors.dates[index].end &&
                  errors.dates[index].end.time && (
                    <span className="invalid-message">
                      {errors.dates[index].end.time.message}
                    </span>
                  )}
              </div>
            )}
          />
        </div>
      </div>
      <div
        style={{
          width: 32,
          flex: "0 0 32px",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          paddingTop: 40,
        }}
      >
        <Icon
          name="trash"
          style={{ cursor: "pointer" }}
          onClick={() => remove(index)}
          disabled={fields.length === 1}
        ></Icon>
      </div>
    </div>
  );
};

const UpdateEventModal = ({ isOpen, closeModal, event }) => {
  const {
    fields,
    append,
    remove,
    form,
    control,
    onFormSubmit,
    uploadImage,
    loadingImageField,
    imageEn,
    imageAr,
  } = useEventForm(event, { closeModal });
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = form;

  const renderImageUpload = (field, value) => (
    <div className="form-control-wrap">
      <input
        type="file"
        id={`${field}-input`}
        multiple={false}
        hidden
        accept="image/png, image/gif, image/jpeg"
        onChange={(e) => {
          if (e.target.files) {
            const file = e.target.files[0];
            const data = new FormData();
            data.append("image", file);
            uploadImage(data, field);
          }
        }}
      />
      <label htmlFor={`${field}-input`}>
        {loadingImageField === field ? (
          <div className="w-150px h-150px d-flex align-items-center justify-content-center border">
            <Spinner />
          </div>
        ) : (
          <div className="w-150px h-150px d-flex align-items-center justify-content-center border">
            {value ? (
              <img
                src={value}
                width={150}
                height={150}
                alt="image"
                style={{
                  objectFit: "cover",
                }}
              />
            ) : (
              <Icon
                name="upload"
                style={{
                  fontSize: "30px",
                }}
              />
            )}
          </div>
        )}
      </label>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => closeModal()}
      className="modal-dialog-centered"
      size="xl"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">{event != null ? "Update" : "Add"} Event</h5>
          <div className="mt-4">
            <Form
              className="row gy-4 form-validate"
              noValidate
              onSubmit={handleSubmit(onFormSubmit)}
            >
              <Col md="6">
                <div className="form-group">
                  <Label className="form-label" htmlFor="fv-name-en">
                    Title (English)
                  </Label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      id="fv-name-en"
                      {...register("nameEn")}
                      className="form-control"
                      placeholder="Enter title in English"
                    />
                    {errors.nameEn && (
                      <span className="invalid">{errors.nameEn.message}</span>
                    )}
                  </div>
                </div>
              </Col>
              <Col md="6">
                <div className="form-group">
                  <Label className="form-label" htmlFor="fv-name-ar">
                    Title (Arabic)
                  </Label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      id="fv-name-ar"
                      dir="rtl"
                      {...register("nameAr")}
                      className="form-control"
                      placeholder="أدخل العنوان بالعربية"
                    />
                  </div>
                </div>
              </Col>
              <Col md="6">
                <div className="form-group">
                  <Label className="form-label" htmlFor="fv-desc-en">
                    Description (English)
                  </Label>
                  <div className="form-control-wrap">
                    <textarea
                      type="textarea"
                      className="form-control form-control-sm"
                      id="fv-desc-en"
                      {...register("descEn")}
                      placeholder="Enter description in English"
                    />
                  </div>
                </div>
              </Col>
              <Col md="6">
                <div className="form-group">
                  <Label className="form-label" htmlFor="fv-desc-ar">
                    Description (Arabic)
                  </Label>
                  <div className="form-control-wrap">
                    <textarea
                      type="textarea"
                      className="form-control form-control-sm"
                      id="fv-desc-ar"
                      dir="rtl"
                      {...register("descAr")}
                      placeholder="أدخل الوصف بالعربية"
                    />
                  </div>
                </div>
              </Col>
              {fields.map((item, index) => (
                <DateItemPicker
                  key={index}
                  index={index}
                  control={control}
                  item={item}
                  errors={errors}
                  fields={fields}
                  remove={remove}
                />
              ))}

              <div className="align-center flex-wrap flex-sm-nowrap">
                <Button
                  color="primary"
                  size="md"
                  type="button"
                  onClick={() =>
                    append({
                      start: { date: null, time: null },
                      end: { date: null, time: null },
                    })
                  }
                >
                  Add date
                </Button>
                {errors.dates && (
                  <span className="invalid-message" style={{ marginLeft: 10 }}>
                    {errors.dates.message}
                  </span>
                )}
              </div>

              <Col md="6">
                <div className="form-group">
                  <Label className="form-label" htmlFor="fv-location">
                    Location
                  </Label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      id="fv-location"
                      {...register("location")}
                      className="form-control"
                    />
                    {errors.location && (
                      <span className="invalid">{errors.location.message}</span>
                    )}
                  </div>
                </div>
              </Col>
              <Col md="6">
                <div className="form-group">
                  <Label className="form-label" htmlFor="fv-link">
                    Link
                  </Label>
                  <div className="form-control-wrap">
                    <input
                      type="text"
                      id="fv-link"
                      {...register("link")}
                      className="form-control"
                    />
                    {errors.link && (
                      <span className="invalid">{errors.link.message}</span>
                    )}
                  </div>
                </div>
              </Col>
              <Col sm="6">
                <div className="form-group">
                  <label className="form-label">Image (English)</label>
                  {renderImageUpload("imageEn", imageEn)}
                  {errors.imageEn && !imageEn && (
                    <span className="invalid-message">
                      {errors.imageEn.message}
                    </span>
                  )}
                </div>
              </Col>
              <Col sm="6">
                <div className="form-group">
                  <label className="form-label">Image (Arabic, optional)</label>
                  {renderImageUpload("imageAr", imageAr)}
                </div>
              </Col>
              <Col size="12">
                <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                  <li>
                    <Button color="primary" size="md" type="submit">
                      {isSubmitting ? (
                        <Spinner size="sm" color="light" />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </li>
                  <li>
                    <a
                      href="#cancel"
                      onClick={(ev) => {
                        ev.preventDefault();
                        closeModal();
                      }}
                      className="link link-light"
                    >
                      Cancel
                    </a>
                  </li>
                </ul>
              </Col>
            </Form>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default UpdateEventModal;
